<script lang="ts" setup>
import type { ApiFormsForm } from '~~/server/api/forms/form'

const route = useRoute()

const { data: page, redirect } = await useFetchWithRedirect<ApiFormsForm>(
    '/api/forms/form',
    { route },
    {
        query: {
            id: route.params.id,
        },
    }
)

if(redirect && !redirect?.error) {
    navigateTo(redirect.data.url, redirect.data.options)
}

if (Object.keys(route.query).length > 0) {
    useCanonicalHead({})
}
const displayColumnLayout = computed(() => {
    return page.value?.data.communication_type === 'crm-api' && !page.value?.data.is_contest_form
})

// Page meta
usePageMeta({
    meta: page.value?.data.meta,
    title: page.value?.data.title,
})
</script>
<template>
  <ContainerFluid v-if="page">
    <Breadcrumbs
      :current="page.data.title"
      :links="[]"
    />

    <article class="mt-12 mb-12">
      <div class="row justify-content-between">
        <div
          class="col-12"
          :class="{
            'col-lg-4': displayColumnLayout,
            'mb-4 mb-md-6': !displayColumnLayout,
          }"
        >
          <PagesOnlineServicesHeader :data="page.data" />
          <PagesOnlineServicesAdvantages
            v-if="
              displayColumnLayout &&
                page.data.advantages?.advantage &&
                page.data.advantages.advantage.length > 0
            "
            :data="page.data.advantages"
          />
        </div>
        <div
          class="col-12"
          :class="{
            'col-lg-8 col-xl-7':
              displayColumnLayout,
          }"
        >
          <aside
            class="bg-white box-shadow-1 p-4 p-md-5 p-lg-12 rounded-4"
          >
            <Tracker :data="{ position: page.data.title }">
              <FormKitWrapper
                :form-id="`${route.params.id}`"
                :download-document="
                  page.data.document_to_download
                "
                :fields="page.data.fields"
              />
            </Tracker>
          </aside>
        </div>
      </div>
    </article>
  </ContainerFluid>
</template>
